export default [
  {
    path: '/email/verify/:token',
    name: 'email-verify',
    component: () => import('@/views/Client/VerifyEmail.vue'),
    meta: {
      layout: 'full',
    },
  },

  {
    path: '/password/reset',
    name: 'password-reset',
    component: () => import('@/views/Client/ForgotPassword.vue'),
    meta: {
      layout: 'full',
    },
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/register/:username',
    name: 'register',
    component: () => import('@/views/Register.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/permission',
    name: 'permission list',
    component: () => import('@/views/AccessControl/Permission.vue'),
    meta: {
      pageTitle: 'Permissions',
      breadcrumb: [
        {
          text: 'Permissions',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('@/views/AccountSetting/AccountSetting'),
    meta: {
      pageTitle: 'Account',
      breadcrumb: [
        {
          text: 'Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/role',
    name: 'role permission edit',
    component: () => import('@/views/AccessControl/Role.vue'),
    meta: {
      pageTitle: 'Roles',
      breadcrumb: [
        {
          text: 'Roles',
          active: true,
        },
      ],
    },
  },
]
